export default __webpack_public_path__ + "static/media/Ntorq125Racing_LateralIzq.b09039f8.webp";